import { Box, Grid, InputAdornment, Typography } from '@mui/material';
import React, { createRef, useEffect,useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { TextBoxLatest } from '../../common/TextBoxLatest/TextBoxLatest';
import { createStyles, makeStyles } from '@mui/styles';
import SearchIcon from "@mui/icons-material/Search";
import { IState } from '../../../redux/reducers/rootReducers';
import { connect, useDispatch } from 'react-redux';
import { globalSearchSSP } from '../../../redux/actions/GlobalSearch/GlobalSearch';
import { handleTime } from '../../helpers/helperFunctions';
import {ViewModal} from '../../../components/SelfServicePortal/WorkCenter/WorkCenterNew'

const isHtml = (text = "") => /<\/?[a-z][\s\S]*>/i.test(text);

// converting to plaintext
const htmlToPlainText = (html = "") => {
  if (!html) return "-";
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
function SearchResults(props:any) {
  const {loggedContact} = props;
  return <> {loggedContact?.id && <SearchResults1 {...props} />}</>
}
function SearchResults1(props:any) {
  const {AllContactAid, articleList, contactTickets,loggedContact={}} = props;
  const param = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchRef:any = createRef();
  const classes = useStyles();
  useEffect(()=>{
    console.log("param v",param.value)
   let decodedSearch = decodeURIComponent(param.value || "");
     searchRef.current.value = decodedSearch || "";
      dispatch(globalSearchSSP(loggedContact?.id,decodedSearch || ""))
  },[param.value])
  const [view,setView] = useState(0)
 
  const onchangeHandler = () =>{
//     console.log("onchangeHandler", searchRef.current.value)
    handleTime.cancel();
    handleTime.setup(()=>{
      navigate(`/SearchResults/${encodeURIComponent(searchRef.current.value)}`)
    },500);
  }
  /* ==== callbacks ==== */
  const articleCB = (id:number)=>{
    navigate(`/ArticlesList/${id}`)
  }
  const serviceCB = (id:number)=>{
    navigate(`/ViewService?id=${id}`)
  }
  const ticketsCB = (id:number)=>{
    setView(id)
  }
  

  return (
    <>
      <Box className="p-2">
        {view != 0 && <ViewModal id={view} setViewId={setView}/>}
        
        <Box className="pb-1">
          <Typography className="text-center pb-1" variant='h5'>Search Results</Typography>
          <TextBoxLatest
              multiline={false}
              placeholder="Please Enter"
              title={""}
              ref={searchRef}
              onchangeHandler={onchangeHandler}
              isMandotary={false}
              errorMsg={``}
              isError={false}
              name='search'
              type="search"
              parentClassNames = "ssp-global-search"
              InputProps={{
                  classes: { input: classes.input1 },
                  endAdornment: (
                      <InputAdornment onClick={()=>{
                        onchangeHandler()
                      }} className='icon-holder' position="end">
                      <SearchIcon className={`${classes.searchIcon} ssp-home-search-icon`} />
                      </InputAdornment>
                  ),
              }}
          />
        </Box>
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <Typography>Tickets</Typography>
                <aside className="aside" style={{height:"calc(100vh - 120px)",overflowY:"auto",overflowX:'hidden'}}>
                  {(!contactTickets?.map || contactTickets.length===0) && <NoDataFound />}
                  {contactTickets?.map && contactTickets?.map((i:any,index:number)=>{
                    const {title,description} = i.ticketLogs;
                    return (
                      <React.Fragment key={index}>
                        <ListItem
                          callback={ticketsCB} 
                          id = {i.id}
                          label = {title}
                           description = {isHtml(description)
                            ? htmlToPlainText(description)
                            : description}
                        />
                      </React.Fragment>
                    )
                  })}
                </aside>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography>Services</Typography>
              <aside className="aside" style={{height:"calc(100vh - 120px)",overflowY:"auto",overflowX:'hidden'}}>
                {(!AllContactAid?.map || AllContactAid.length===0) && <NoDataFound />}
                {AllContactAid?.map && AllContactAid?.map((i:any,index:number)=>{
                  const {name,description,id} = i;
                  return (
                    <React.Fragment key={index}>
                      <ListItem
                        callback={serviceCB} 
                        id = {id}
                        label = {name}
                        description = {description}
                      />
                    </React.Fragment>
                  )
                })}
              </aside>
            </Grid>
           
            <Grid item xs={12} md={4}>
                <Typography>Articles</Typography>
                <aside className="aside"style={{height:"calc(100vh - 120px)",overflowY:"auto",overflowX:'hidden'}}>
                  {(!articleList?.map || articleList.length===0) && <NoDataFound />}
                  {articleList?.map && articleList?.map((i:any,index:number)=>{
                    const {name,keywords,id} = i;
                    return (
                      <React.Fragment key={index}>
                        <ListItem
                          callback={articleCB} 
                          id = {id}
                          label = {name}
                          description = {keywords}
                        />
                      </React.Fragment>
                    )
                  })}
                </aside>
            </Grid>
        </Grid>
      </Box>
    </>
  )
}

const NoDataFound = () =>{
  return(
  <Box className="p-2 text-center">
    <Typography>No Records Found</Typography>
  </Box>)
}
interface IListItem {
  id : number;
  label : string;
  description : string;
  callback:any;
}
const ListItem = (props:IListItem) =>{
  const {id, label, description, callback} = props;
   const [ticket,setTicket] = useState(0)
  return(<>
    <Box onClick={()=>callback(id)} className="search-result-item">
      <Typography><span className='text-primary' onClick={() => setTicket(id)}>#{id}</span> {" "} {label}</Typography>
      <Typography className="desc">{description}</Typography>
    </Box>
  </>)
}

const useStyles = makeStyles(() =>
  createStyles({
    input1: {
      fontSize: "13px",
      fontWeight: 400,
    },
    searchIcon: {
      fontSize: "16px",
      color:"#5572df"
    },
  }
))

const mapStateToProps = (state:IState) => {
  return ({
    AllContactAid : state?.ContactsReducer?.AllContactAid,
    articleList : state?.KnowledgeBaseReducer?.articleList,
    contactTickets : state?.ContactsReducer?.contactTickets,
    loggedContact : state?.ContactsReducer?.loggedContact
  })
};

export default connect(mapStateToProps)(SearchResults);